import './assets/css/normalize.css'
import './assets/css/table.scss'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { Icon } from 'ant-design-vue'

const app = createApp(App)
app.use(store).use(router).mount('#app')

app.use(Icon)
